import React from "react";
import InvoiceStatusSection from "./invoiceStatus/InvoiceStatusSection";
import MailTemplateSection from "./mailTemplate/MailTemplateSection";

const InvoiceConfigSection = ({ userDetails, selectedClient }) => {
  return (
    <div className='grid-container'>
      <InvoiceStatusSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
      <MailTemplateSection
        userDetails={userDetails}
        selectedClient={selectedClient}
      />
    </div>
  );
};

export default InvoiceConfigSection;
